import { newUserPlans } from 'UserPlans/userPlans'
import { observable, action, decorate } from 'mobx'
import { FormattedMessage } from 'react-intl'

export const HeaderActions = {
  EDIT: {
    title: <FormattedMessage id="pages.formMaker.header.action.edit" />,
    slug: 'edit',
    accessDenied: [],
  },
  SETTINGS: {
    title: <FormattedMessage id="pages.formMaker.header.action.settings" />,
    slug: 'settings',
    accessDenied: [],
  },
  DESIGN: {
    title: <FormattedMessage id="pages.formMaker.header.action.design" />,
    slug: 'design',
    accessDenied: [],
  },
  NOTIFICATION: {
    title: <FormattedMessage id="pages.formMaker.header.action.notification" />,
    slug: 'notification',
    accessDenied: [],
    userPlanDenied: [newUserPlans.FREE],
  },
  LOGIC: {
    title: <FormattedMessage id="pages.formMaker.header.action.logic" />,
    slug: 'logic',
    accessDenied: ['nps', 'read', 'editor'],
  },
  CALCULATOR: {
    title: <FormattedMessage id="pages.formMaker.header.action.calculator" />,
    slug: 'calculator',
    accessDenied: ['nps', 'read', 'editor'],
  },
  RESULT: {
    title: <FormattedMessage id="pages.formMaker.header.action.result" />,
    slug: 'app',
    accessDenied: [],
  },
}

class formHeaderStore {
  currentState = 'edit'

  setCurrentState = (state) => {
    this.currentState = state
  }
}
decorate(formHeaderStore, {
  currentState: observable,
  setCurrentState: action,
})
const FormHeader = new formHeaderStore()

export const updateHeaderState = (stateSlug) =>
  FormHeader.setCurrentState(stateSlug)

export default FormHeader
